import { useEffect } from 'react';
import useWidth from '../../../../components/Hooks/useWidth';
import signedContractsStore from '../../../../stores/SignedContracts/SignedContracts.store';
import { useSignatureContext } from '../contexts/signature.context';
import useLoadSignedContracts from '../hooks/useLoadSignedContracts';
import ContractHistoryCardList from './ContractHistoryCardList';
import ContractHistoryTable from './ContractHistoryTable';

type Props = {
  orderId?: string;
};

export const ContractHistory = ({ orderId }: Props) => {
  const { isLoadingToFalse } = useSignatureContext();
  const { smallWidth } = useWidth();
  const { loadSignedContracts } = useLoadSignedContracts(orderId ?? '');

  useEffect(() => {
    if (orderId) {
      loadSignedContracts().finally(isLoadingToFalse);
    }

    return () => {
      signedContractsStore.reset();
    };
  }, []);

  if (smallWidth) {
    return <ContractHistoryCardList />;
  }

  return <ContractHistoryTable />;
};
